import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Reply from './reply-model'
import {
  CreateReplyAsync,
  DeleteReplyAsync,
  LoadReplysAsync,
} from './reply-thunk'
const initialState: replySliceState = {
  reply: [],
  selected_reply: '',
  is_loading_reply: false,
  is_creating_reply: false,
  is_deleting_reply: false,
}
export interface replySliceState {
  reply: Reply[]
  selected_reply?: string
  is_loading_reply: boolean
  is_creating_reply: boolean
  is_deleting_reply: boolean
}
export const replySlice = createSlice({
  name: 'reply',
  initialState,
  reducers: {
    setSelectedreply: (state, action) => {
      state.selected_reply = action.payload
    },
    clearStatereply: (state) => {
      state.reply = []
      state.is_loading_reply = false
      state.is_creating_reply = false
      state.is_deleting_reply = false
    },
    mergereply: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_reply = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.reply = merge(state.reply, payload) as any
        }
      }
    },

    add_reply: (state, action) => {
      if (action.payload) {
        state.reply = [...state.reply, action.payload]
      }
    },
    set_reply: (state, action) => {
      let { key, value, id } = action.payload
      state.reply = state.reply.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadReplysAsync.pending, (state) => {
      state.is_loading_reply = true
    })
    builder.addCase(LoadReplysAsync.fulfilled, (state, action) => {
      state.is_loading_reply = false
      if (action.payload) {
        state.reply = action.payload
      }
    })
    builder.addCase(LoadReplysAsync.rejected, (state) => {
      state.is_loading_reply = false
    })
    builder.addCase(CreateReplyAsync.pending, (state) => {
      state.is_creating_reply = true
    })
    builder.addCase(CreateReplyAsync.fulfilled, (state) => {
      state.is_creating_reply = false
    })
    builder.addCase(CreateReplyAsync.rejected, (state) => {
      state.is_creating_reply = false
    })
    builder.addCase(DeleteReplyAsync.pending, (state) => {
      state.is_deleting_reply = true
    })
    builder.addCase(DeleteReplyAsync.fulfilled, (state, action) => {
      state.is_deleting_reply = false
      if (state.reply) {
        state.reply = state.reply.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteReplyAsync.rejected, (state) => {
      state.is_deleting_reply = false
    })
  },
})

export const {
  clearStatereply,
  setSelectedreply,
  set_reply,
  mergereply,
  add_reply,
} = replySlice.actions

export const get_reply =
  (id?: string) =>
  (state: {
    reply: {
      reply: Reply[]
    }
  }): Reply | null => {
    let temp = state?.reply?.reply?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.reply?.reply[0] || null
  }
export const get_selected_reply = (state: {
  reply: replySliceState
}): Reply | null => {
  let id = state?.reply?.selected_reply
  let temp = state?.reply?.reply?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_reply = (state: {
  reply: {
    reply: Reply[]
  }
}): Reply[] => {
  let temp = state?.reply?.reply
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_reply_busy = (state: { reply: replySliceState }) => {
  return (
    state?.reply.is_deleting_reply ||
    state?.reply.is_loading_reply ||
    state?.reply.is_creating_reply
  )
}
export const is_deleting_reply_busy = (state: { reply: replySliceState }) => {
  return state?.reply.is_deleting_reply
}
export const is_loading_reply_busy = (state: { reply: replySliceState }) => {
  return state?.reply.is_loading_reply
}
export const is_creating_reply_busy = (state: { reply: replySliceState }) => {
  return state?.reply.is_creating_reply
}

export default replySlice.reducer
